import React, { FC } from 'react';
import './LoadingSpinner.css';

interface Props {
  size?: 'large' | 'small';
}

export const LoadingSpinner: FC<Props> = ({ size = 'small' }) => {
  return (
    <div className={`lds-ring ${size}`}>
      <div className={`${size}`}></div>
      <div className={`${size}`}></div>
      <div className={`${size}`}></div>
      <div className={`${size}`}></div>
    </div>
  );
};
